import { FC } from "react";
import Modal from "components/Modal";
import { useUnlinkTelegramMutation } from "../api/twoFactorAuthApi";
import { getTelegramLinkError } from "../model/getTelegramLinkError";

import styles from "./TelegramUnlinkModal.module.css";

interface Props {
  onClose: () => void;
}

export const TelegramUnlinkModal: FC<Props> = ({ onClose }) => {
  const [unlink, { isLoading, error }] = useUnlinkTelegramMutation();

  const handleUnlink = async () => {
    await unlink();
    onClose();
  };

  return (
    <Modal isOpen onClose={onClose} title="Unlink Telegram">
      <div className={styles.content}>
        <p className={styles.message}>
          Telegram 2FA will be disabled and this account will no longer be
          linked. Continue?
        </p>

        {error && (
          <p className={styles.error}>{getTelegramLinkError(error)}</p>
        )}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={handleUnlink}
            disabled={isLoading}
          >
            {isLoading ? "Unlinking..." : "Unlink"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
